export class SearchRequest {
  constructor(
    public name: string = null,
    public organizationCode: string = null,
    public gradeCode: string = null,
    public jobCode: string = null,
    public appointmentYear?: string
  ) {}
}
